/* eslint-disable */

/*
    json_parse.js
    2012-06-20

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    This file creates a json_parse function.

        json_parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = json_parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

    This is a reference implementation. You are free to copy, modify, or
    redistribute.

    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.
*/

/* members "", "\"", "\/", "\\", at, b, call, charAt, f, fromCharCode,
    hasOwnProperty, message, n, name, prototype, push, r, t, text
*/
var util = require('util')

// wraps a large number, does not support arithmetic

function BigNumber (number) {
  this.numberStr = number.toString()

  // not a number
  if (isNaN(parseFloat(this.numberStr)) === true ||
        isFinite(this.numberStr) === false) {
    throw new Error(number + ' is not a number')
  }
}
util.inherits(BigNumber, Object)

BigNumber.prototype.toString = function () {
  return this.numberStr
}

function f (n) {
  // Format integers to have at least two digits.
  return n < 10 ? '0' + n : n
}

var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g

var escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g

var gap

var indent

var meta = { // table of character substitutions
  '\b': '\\b',
  '\t': '\\t',
  '\n': '\\n',
  '\f': '\\f',
  '\r': '\\r',
  '"': '\\"',
  '\\': '\\\\'
}

var rep

function quote (string) {
  // If the string contains no control characters, no quote characters, and no
  // backslash characters, then we can safely slap some quotes around it.
  // Otherwise we must also replace the offending characters with safe escape
  // sequences.

  escapable.lastIndex = 0
  return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
    var c = meta[a]
    return typeof c === 'string'
      ? c
      : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4)
  }) + '"' : '"' + string + '"'
}

function str (key, holder) {
  // Produce a string from holder[key].

  var i
  // The loop counter.

  var k
  // The member key.

  var v
  // The member value.

  var length

  var mind = gap

  var partial

  var value = holder[key]

  // If the value has a toJSON method, call it to obtain a replacement value.

  if (value && typeof value === 'object' &&
            typeof value.toJSON === 'function') {
    value = value.toJSON(key)
  }

  // If we were called with a replacer function, then call the replacer to
  // obtain a replacement value.

  if (typeof rep === 'function') {
    value = rep.call(holder, key, value)
  }

  // What happens next depends on the value's type.

  switch (typeof value) {
    case 'string':
      return quote(value)

    case 'number':

      // JSON numbers must be finite. Encode non-finite numbers as null.

      return isFinite(value) ? String(value) : 'null'

    case 'boolean':
    case 'null':

      // If the value is a boolean or null, convert it to a string. Note:
      // typeof null does not produce 'null'. The case is included here in
      // the remote chance that this gets fixed someday.

      return String(value)

      // If the type is 'object', we might be dealing with an object or an array or
      // null.

    case 'object':

      // Due to a specification blunder in ECMAScript, typeof null is 'object',
      // so watch out for that case.

      if (!value) {
        return 'null'
      }

      // Handle big numbers.

      if (value instanceof BigNumber) {
        return value.toString()
      }

      // Make an array to hold the partial results of stringifying this object value.

      gap += indent
      partial = []

      // Is the value an array?

      if (Object.prototype.toString.apply(value) === '[object Array]') {
        // The value is an array. Stringify every element. Use null as a placeholder
        // for non-JSON values.

        length = value.length
        for (i = 0; i < length; i += 1) {
          partial[i] = str(i, value) || 'null'
        }

        // Join all of the elements together, separated with commas, and wrap them in
        // brackets.

        v = partial.length === 0
          ? '[]'
          : gap
            ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']'
            : '[' + partial.join(',') + ']'
        gap = mind
        return v
      }

      // If the replacer is an array, use it to select the members to be stringified.

      if (rep && typeof rep === 'object') {
        length = rep.length
        for (i = 0; i < length; i += 1) {
          if (typeof rep[i] === 'string') {
            k = rep[i]
            v = str(k, value)
            if (v) {
              partial.push(quote(k) + (gap ? ': ' : ':') + v)
            }
          }
        }
      } else {
        // Otherwise, iterate through all of the keys in the object.

        for (k in value) {
          if (Object.prototype.hasOwnProperty.call(value, k)) {
            v = str(k, value)
            if (v) {
              partial.push(quote(k) + (gap ? ': ' : ':') + v)
            }
          }
        }
      }

      // Join all of the member texts together, separated with commas,
      // and wrap them in braces.

      v = partial.length === 0
        ? '{}'
        : gap
          ? '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}'
          : '{' + partial.join(',') + '}'
      gap = mind
      return v
  }
}

export const stringify = function (value, replacer, space) {
  // The stringify method takes a value and an optional replacer, and an optional
  // space parameter, and returns a JSON text. The replacer can be a function
  // that can replace values, or an array of strings that will select the keys.
  // A default replacer method can be provided. Use of the space parameter can
  // produce text that is more easily readable.

  var i
  gap = ''
  indent = ''

  // If the space parameter is a number, make an indent string containing that
  // many spaces.

  if (typeof space === 'number') {
    for (i = 0; i < space; i += 1) {
      indent += ' '
    }

    // If the space parameter is a string, it will be used as the indent string.
  } else if (typeof space === 'string') {
    indent = space
  }

  // If there is a replacer, it must be a function or an array.
  // Otherwise, throw an error.

  rep = replacer
  if (replacer && typeof replacer !== 'function' &&
            (typeof replacer !== 'object' ||
            typeof replacer.length !== 'number')) {
    throw new Error('bignumJSON.stringify')
  }

  // Make a fake root object containing our value under the key of ''.
  // Return the result of stringifying the value.

  return str('', { '': value })
}

export const parse = (function () {
  'use strict'

  // This is a function that can parse a JSON text, producing a JavaScript
  // data structure. It is a simple, recursive descent parser. It does not use
  // eval or regular expressions, so it can be used as a model for implementing
  // a JSON parser in other languages.

  // We are defining the function inside of another function to avoid creating
  // global variables.

  var at
  // The index of the current character

  var ch
  // The current character

  var escapee = {
    '"': '"',
    '\\': '\\',
    '/': '/',
    b: '\b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t'
  }

  var text

  // If true, duplicate properties are allowed and the last definition will be used
  // e.g. '{"hello": "world1", "hello": "world2"}' -> {"hello": "world2"}
  // If false, duplicate properties result in a SyntaxError.

  var allowDuplicateProperties = true

  var error = function (m) {
    // Call error when something is wrong.

    throw {
      name: 'SyntaxError',
      message: m,
      at: at,
      text: text
    }
  }

  var next = function (c) {
    // If a c parameter is provided, verify that it matches the current character.

    if (c && c !== ch) {
      error("Expected '" + c + "' instead of '" + ch + "'")
    }

    // Get the next character. When there are no more characters,
    // return the empty string.

    ch = text.charAt(at)
    at += 1
    return ch
  }

  var number = function () {
    // Parse a number value.

    var number

    var string = ''

    if (ch === '-') {
      string = '-'
      next('-')
    }
    while (ch >= '0' && ch <= '9') {
      string += ch
      next()
    }
    if (ch === '.') {
      string += '.'
      while (next() && ch >= '0' && ch <= '9') {
        string += ch
      }
    }
    if (ch === 'e' || ch === 'E') {
      string += ch
      next()
      if (ch === '-' || ch === '+') {
        string += ch
        next()
      }
      while (ch >= '0' && ch <= '9') {
        string += ch
        next()
      }
    }

    number = +string

    if (!isFinite(number)) {
      error('Bad number')
    } else {
      // means JS rounded or truncated number, too big
      if (number.toString().length > 12 || number.toString() !== string) {
        try {
          return new BigNumber(string)
        } catch (e) {
          // if fails, fallback to default behavior
        }
      }

      return number
    }
  }

  var string = function () {
    // Parse a string value.

    var hex

    var i

    var string = ''

    var uffff

    // When parsing for string values, we must look for " and \ characters.

    if (ch === '"') {
      while (next()) {
        if (ch === '"') {
          next()
          return string
        }
        if (ch === '\\') {
          next()
          if (ch === 'u') {
            uffff = 0
            for (i = 0; i < 4; i += 1) {
              hex = parseInt(next(), 16)
              if (!isFinite(hex)) {
                break
              }
              uffff = uffff * 16 + hex
            }
            string += String.fromCharCode(uffff)
          } else if (typeof escapee[ch] === 'string') {
            string += escapee[ch]
          } else {
            break
          }
        } else {
          string += ch
        }
      }
    }
    error('Bad string')
  }

  var white = function () {
    // Skip whitespace.

    while (ch && ch <= ' ') {
      next()
    }
  }

  var word = function () {
    // true, false, or null.

    switch (ch) {
      case 't':
        next('t')
        next('r')
        next('u')
        next('e')
        return true
      case 'f':
        next('f')
        next('a')
        next('l')
        next('s')
        next('e')
        return false
      case 'n':
        next('n')
        next('u')
        next('l')
        next('l')
        return null
    }
    error("Unexpected '" + ch + "'")
  }

  var value
  // Place holder for the value function.

  var array = function () {
    // Parse an array value.

    var array = []

    if (ch === '[') {
      next('[')
      white()
      if (ch === ']') {
        next(']')
        return array // empty array
      }
      while (ch) {
        array.push(value())
        white()
        if (ch === ']') {
          next(']')
          return array
        }
        next(',')
        white()
      }
    }
    error('Bad array')
  }

  var object = function () {
    // Parse an object value.

    var key

    var object = {}

    if (ch === '{') {
      next('{')
      white()
      if (ch === '}') {
        next('}')
        return object // empty object
      }
      while (ch) {
        key = string()
        white()
        next(':')
        if (!allowDuplicateProperties &&
                        Object.hasOwnProperty.call(object, key)) {
          error('Duplicate key "' + key + '"')
        }
        object[key] = value()
        white()
        if (ch === '}') {
          next('}')
          return object
        }
        next(',')
        white()
      }
    }
    error('Bad object')
  }

  value = function () {
    // Parse a JSON value. It could be an object, an array, a string, a number,
    // or a word.

    white()
    switch (ch) {
      case '{':
        return object()
      case '[':
        return array()
      case '"':
        return string()
      case '-':
        return number()
      default:
        return ch >= '0' && ch <= '9' ? number() : word()
    }
  }

  // Return the json_parse function. It will have access to all of the above
  // functions and variables.

  return function (source, reviver, _allowDuplicateProperties) {
    var result

    if (_allowDuplicateProperties !== undefined) {
      allowDuplicateProperties = _allowDuplicateProperties
    }

    text = source
    at = 0
    ch = ' '
    result = value()
    white()
    if (ch) {
      error('Syntax error')
    }

    // If there is a reviver function, we recursively walk the new structure,
    // passing each name/value pair to the reviver function for possible
    // transformation, starting with a temporary root object that holds the result
    // in an empty key. If there is not a reviver function, we simply return the
    // result.

    var ret = typeof reviver === 'function'
      ? (function walk (holder, key) {
        var k; var v; var value = holder[key]
        if (value && typeof value === 'object') {
          for (k in value) {
            if (Object.prototype.hasOwnProperty.call(value, k)) {
              v = walk(value, k)
              if (v !== undefined) {
                value[k] = v
              } else {
                delete value[k]
              }
            }
          }
        }
        return reviver.call(holder, key, value)
      }({ '': result }, ''))
      : result

    // Set text to null so we don't retain a reference to the original text
    // after this function returns.

    text = null
    return ret
  }
}())
